import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { logout, getCurrentUserId } from "../utils/auth";
import { toast } from "react-toastify";
import { getSidebarMenus } from "../constants/sidebarMenus";
import { useProfile } from "../hook/useProfile";
import TopHeader from "../components/comman/TopHeader";
import Sidebar from "../components/comman/Sidebar";
// import api from "../utils/api";
import "../css/Donation.css";
import api from "../api/axios";
import xzy from "../assets/images/Coverpage.jpg";
import { IoIosArrowForward } from "react-icons/io";
import QR from "../assets/QR.avif";
import Input from "../components/ui/Input/Input";
import RevolutionEmail from "../components/model/RevolutionEmail";
import DonationStatus from "../components/DonationStatus";

function Donation() {
  const currentUserId = getCurrentUserId();
  const { isProfileInfo } = useProfile();
  const isDonationPermission = isProfileInfo?.donationPermission;
  const sidebarMenus = getSidebarMenus(currentUserId);
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [activeSidebar, setActiveSidebar] = useState("donation");
  const [showSidebar, setShowSidebar] = useState(true);
  const [showMsgDrawer, setShowMsgDrawer] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const userID = isProfileInfo._id;
  const [isLoading, setIsLoading] = useState(true);
  const [errors, setErrors] = useState({
    name: "",
    phone: "",
    upiId: "",
    declaration: "",
  });
  const [showRejectedForm, setShowRejectedForm] = useState(false);

  const [form, setForm] = useState({
    name: "",
    phone: "",
    upiId: "",
    declaration: false,
  });

  const [qrFile, setQrFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleLogout = () => {
    logout();
    navigate("/login", { replace: true });
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    let updatedValue = value;

    // Name: Only alphabets + space
    if (name === "name") {
      updatedValue = value
        .replace(/[^a-zA-Z\s]/g, "")
        .replace(/\s{2,}/g, " ")
        .trimStart();
    }

    // Phone: Only numbers (max 10 digits)
    if (name === "phone") {
      updatedValue = value.replace(/\D/g, "").slice(0, 10);
    }

    // UPI ID: Strict validation + max 30 chars
    if (name === "upiId") {
      updatedValue = value
        .toLowerCase()
        .replace(/[^a-z0-9@._]/g, "") // allow only valid chars
        .replace(/\.{2,}/g, ".") // prevent multiple dots
        .replace(/@{2,}/g, "@") // prevent multiple @
        .slice(0, 30); // stop infinite typing
    }

    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : updatedValue,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!["image/png", "image/jpeg"].includes(file.type)) {
      toast.error("Only PNG or JPG allowed");
      return;
    }
    setQrFile(file);
  };

  const validate = () => {
    const newErrors = {
      name: "",
      phone: "",
      upiId: "",
      qrFile: "",
      declaration: "",
    };

    if (!form.name.trim()) newErrors.name = "Name required";
    if (!form.phone.trim()) newErrors.phone = "Phone required";
    else if (!/^[6-9]\d{9}$/.test(form.phone))
      newErrors.phone = "Phone must be a valid 10-digit number";
    if (!form.upiId.includes("@")) newErrors.upiId = "Valid UPI ID required";
    if (!form.declaration) newErrors.declaration = "Please confirm details";

    return newErrors;
  };

  const handleDonation = async () => {
    // alert("new")
    //
    if (!isDonationPermission) {
      setShowPopup(true);
      return true;
    }

    // alert("new")

    const validationErrors = validate();
    setErrors(validationErrors);

    // Stop if validation error
    if (Object.values(validationErrors).some((err) => err)) return;

    try {
      setLoading(true);

      const data = new FormData();
      data.append("name", form.name);
      data.append("phone", form.phone);
      data.append("upiId", form.upiId);
      data.append("declaration", form.declaration);

      if (qrFile) {
        data.append("qrCode", qrFile);
      }

      const res = await api.post("/donation", data, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      // SUCCESS → Show donation status screen (NO redirect)
      toast.success("Submitted for verification!");

      //  rawDonationStatus === "REQUESTED";

      // Force UI to show pending status instantly (no reload needed)
      if (isProfileInfo) {
        isProfileInfo.donationEnabled = "PENDING";
      }
      // Reset form
      setForm({
        name: "",
        phone: "",
        upiId: "",
        declaration: false,
      });
      setQrFile(null);
      setErrors({});

      // IMPORTANT: Do NOT navigate anywhere
      // donationStatus (REQUESTED) will auto show in JSX
    } catch (err) {
      console.log("Donation Error:", err?.response);

      const statusCode = err?.response?.status;
      const backendMessage =
        err?.response?.data?.message || err?.response?.data?.error || "";

      // FIX: Only redirect if backend explicitly says NOT VERIFIED
      if (statusCode === 403 && backendMessage === "AADHAAR_NOT_VERIFIED") {
        toast.error("Please complete Aadhaar verification first");
        navigate("/aadhaar-verification");
        return;
      }

      // Otherwise DO NOT redirect (stay on donation page)
      toast.error(backendMessage || "Submission failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const rawDonationStatus = isProfileInfo?.donationEnabled;

  const donationStatus =
    rawDonationStatus === "ACCEPTED"
      ? "VERIFIED"
      : rawDonationStatus === "PENDING"
        ? "REQUESTED"
        : rawDonationStatus === "REQUESTED"
          ? "REQUESTED"
          : rawDonationStatus === "REJECTED"
            ? "REJECTED"
            : "";

  useEffect(() => {
    if (
      rawDonationStatus === "ACCEPTED" ||
      rawDonationStatus === "PENDING" ||
      rawDonationStatus === "REQUESTED" ||
      rawDonationStatus === "REJECTED" ||
      rawDonationStatus === "NONE"
    ) {
      setIsLoading(false);
    }

    if (rawDonationStatus === "NONE") {
      setShowRejectedForm(true);
    }
  }, [rawDonationStatus]);

  return (
    <div className="container-xxl p-0">
      <div className="feed-page-wrapper">
        <TopHeader
          onToggleSidebar={() => setShowSidebar((prev) => !prev)}
          onOpenMessages={() => setShowMsgDrawer(true)}
          creditAmount={50}
          notificationCount={5}
          messageCount={0}
        />

        <div className="prime-layout-container .container-fluid">
          <div className="row">
            <Sidebar
              showSidebar={showSidebar}
              sidebarMenus={sidebarMenus}
              activeSidebar={activeSidebar}
              onNavigate={(item) => {
                setActiveSidebar(item.key);
                if (item.path) {
                  navigate(item.path);
                }
              }}
              onLogout={handleLogout}
            />

            <div className="col-12 col-md-9 overflow-auto center-area-container">
              {showPopup && (
                <RevolutionEmail
                  popupMSG={
                    "If you want to get the donation button, you need approval from the admin. You can contact the admin at the email address below."
                  }
                  onClose={() => {
                    setShowPopup(false);
                    navigate("/feed/prime");
                  }}
                />
              )}

              {isLoading && (
                <div className="d-flex align-items-center justify-content-center vh-100">
                  <div className="spinner-border theme-color" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              )}

              {donationStatus === "REQUESTED" && !showRejectedForm ? (
                <DonationStatus
                  donationStatus="REQUESTED"
                  onResubmit={() => setShowRejectedForm(true)}
                />
              ) : donationStatus === "REJECTED" && !showRejectedForm ? (
                <DonationStatus
                  donationStatus="REJECTED"
                  onResubmit={() => setShowRejectedForm(true)}
                />
              ) : donationStatus === "VERIFIED" ? (
                <DonationStatus
                  donationStatus="VERIFIED"
                  onResubmit={() => setShowRejectedForm(true)}
                />
              ) : (
                donationStatus === "NONE" ||
                (showRejectedForm && (
                  <div className="donation_container">
                    <div className="donation_section shadow">
                      {/* Profile */}
                      <div className="donation_profile_head">
                        <div
                          onClick={() => navigate(`/my/${userID}/profile`)}
                          className="donation_my_profile"
                        >
                          <img
                            src={
                              isProfileInfo?.profilePic
                                ? `${isProfileInfo.profilePic}`
                                : "https://cdn-icons-png.flaticon.com/512/149/149071.png"
                            }
                            alt="profile"
                          />
                          <div>
                            <h2>{isProfileInfo?.fullName}</h2>
                            <span>Not Verify</span>

                            {/* <span
                              style={{
                                color:
                                  donationStatus === "VERIFIED"
                                    ? "#28a745"
                                    : donationStatus === "REQUESTED"
                                      ? "#ff7a00"
                                      : donationStatus === "REJECTED"
                                        ? "#dc3545"
                                        : "#999",
                                fontWeight: 600,
                              }}
                            >
                              {donationStatus === "VERIFIED"
                                ? "Verified"
                                : donationStatus === "REQUESTED"
                                  ? "Pending"
                                  : donationStatus === "REJECTED"
                                    ? "Rejected"
                                    : "Not Verified"}
                            </span> */}
                          </div>
                        </div>
                      </div>

                      {/* Form */}

                      <div className="personal_details">
                        <h2>Personal Details</h2>

                        <div className="donation_mobile_number">
                          <div className="donation_label">
                            <label>Full Name</label>
                          </div>
                          <div className="donation_mobile_input">
                            <input
                              type="text"
                              name="name"
                              placeholder="Full Name"
                              value={form.name}
                              onChange={handleChange}
                            />
                          </div>

                          {errors.name && (
                            <div className="no_error">
                              <p>{errors.name}</p>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="donation_mobile_number">
                        <div className="donation_label">
                          <label>Mobile Number</label>
                        </div>
                        <div className="donation_mobile_input">
                          <span>+91</span>
                          <input
                            type="number"
                            name="phone"
                            placeholder="Mobile Number"
                            value={form.phone}
                            onChange={handleChange}
                          />
                        </div>
                        {errors.phone && (
                          <div className="no_error">
                            <p>{errors.phone}</p>
                          </div>
                        )}
                      </div>

                      <div className="personal_details">
                        <h2>Payment Details</h2>
                        <div className="donation_mobile_number">
                          <div className="donation_label">
                            <label>UPI ID</label>
                          </div>
                          <div className="donation_mobile_input">
                            <input
                              type="text"
                              name="upiId"
                              placeholder="UPI ID (eg: name@oksbi)"
                              value={form.upiId}
                              onChange={handleChange}
                            />
                          </div>
                          {errors.upiId && (
                            <div className="no_error">
                              <p>{errors.upiId}</p>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="personal_details">
                        <div className="donation_input_fields">
                          <div className="scan_QR_code">
                            <img
                              src={qrFile ? URL.createObjectURL(qrFile) : QR}
                              alt="QR"
                            />
                            <span>Upload Your UPI QR Code (Optional)</span>
                            <label className="file_btn">
                              Select File
                              <input
                                type="file"
                                accept="image/png, image/jpeg"
                                onChange={handleFileChange}
                              />
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="confirmation_message">
                        <label>
                          <input
                            type="checkbox"
                            name="declaration"
                            checked={form.declaration}
                            onChange={handleChange}
                          />
                          <p>I confirm that the above details are correct</p>
                        </label>
                        {errors.declaration && (
                          <div className="no_error">
                            <p>{errors.declaration}</p>
                          </div>
                        )}
                      </div>

                      <div className="submit_verification">
                        <button
                          onClick={() => handleDonation()}
                          disabled={loading}
                        >
                          {loading
                            ? "Submitting..."
                            : "Submit For Verification"}
                        </button>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Donation;
